import produce from "immer";
import { FeeStructureActions } from ".";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";

import { defaultFeeStructure, defaultFeeStructureState } from "./defaultState";
import { CLEAR_FEE, CLEAR_FEE_STATE, FETCH_FEE_LIST_FAILED, FETCH_FEE_LIST_PROGRESS, FETCH_FEE_LIST_SUCCESS } from "./feeStructure.actions";

export const feeStructureReducer = (
  state: IStoreState["feeStructure"] = defaultFeeStructureState,
  action: FeeStructureActions
) => {
  switch (action.type) {
   case FETCH_FEE_LIST_PROGRESS: {
        const newState = produce(state, (draftState) => {
          draftState.list.loading = LoadState.InProgress;
          draftState.list.data = [];
          draftState.list.error = null;
        });
        return newState;
      }
      case FETCH_FEE_LIST_SUCCESS: {
        const { list, totalRecords } = action.payload;
        const newState = produce(state, (draftState) => {
          draftState.list.loading = LoadState.Loaded;
          draftState.list.data = list;
          draftState.list.totalRecords=totalRecords;
        });
        return newState;
      }
      case FETCH_FEE_LIST_FAILED: {
        const newState = produce(state, (draftState) => {
          draftState.list.loading = LoadState.Failed;
        });
        return newState;
      }
         case CLEAR_FEE: {
            const newState = produce(state, (draftState) => {
              draftState.feeStructure.loading = LoadState.NotLoaded;
              draftState.feeStructure.data = defaultFeeStructure;
              draftState.feeStructure.error = null;
            });
            return newState;
          }
      
          case CLEAR_FEE_STATE: {
            return defaultFeeStructureState;
          }
      
    default: {
      return state;
    }
  }
};